export default __webpack_public_path__ + "static/media/romi-noymark.ab675091.png";